/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Col, DatePicker, Form, Row } from 'antd';
import { Moment } from 'moment';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';

interface Props {
  values?: FormValues;
  onFilter?: (values: FormValues) => void;
}

interface FormValues {
  startDate: Moment;
  endDate: Moment;
}

const SyntheticAnalysisFilter: React.FC<Props> = ({ values, onFilter }) => {
  const [form] = Form.useForm<FormValues>();
  const startDate = Form.useWatch('startDate', form);
  const endDate = Form.useWatch('endDate', form);
  const intl = useIntl();

  useEffect(() => {
    if (values) {
      form.setFieldsValue({
        startDate: values.startDate,
        endDate: values.endDate,
      });
    }
  }, [values]);

  const onSubmit = (formValues: FormValues) => {
    if (onFilter) {
      onFilter(formValues);
    }
  };

  return (
    <Form form={form} onFinish={onSubmit}>
      <Row gutter={[24, 24]} align="middle">
        <Col span={24} md={4}>
          <FloatingFormItem
            style={{ marginBottom: 0 }}
            label={intl.formatMessage({
              id: 'searchQuestionnaire.replayDate.filter.startDate',
            })}
            name="startDate"
          >
            <DatePicker
              placeholder=""
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
              disabledDate={(date) => date.isAfter(endDate)}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={4}>
          <FloatingFormItem
            style={{ marginBottom: 0 }}
            label={intl.formatMessage({
              id: 'searchQuestionnaire.replayDate.filter.endDate',
            })}
            name="endDate"
          >
            <DatePicker
              placeholder=""
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
              disabledDate={(date) => date.isBefore(startDate)}
            />
          </FloatingFormItem>
        </Col>
        <Col>
          <Button size="large" htmlType="submit">
            {intl.formatMessage({
              id: 'searchQuestionnaire.replayDate.filter.button',
            })}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SyntheticAnalysisFilter;
